var _namedview, _clipPath, _clipPath2, _feGaussianBlur, _feGaussianBlur2, _feGaussianBlur3, _feGaussianBlur4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVsV003(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27.858mm",
    height: "39.910999mm",
    viewBox: "0 0 27.857999 39.910999",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#111111",
    borderopacity: 1,
    showpageshadow: 0,
    pageopacity: 0,
    pagecheckerboard: 1,
    deskcolor: "#d1d1d1",
    "document-units": "mm",
    zoom: 3.1192093,
    cx: 45.524357,
    cy: 78.064655,
    "window-width": 2787,
    "window-height": 1586,
    "window-x": 8629,
    "window-y": 1582,
    "window-maximized": 1,
    "current-layer": "svg1"
  })), /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath849"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03e-7,138.96 H 612 V 720 H 1.03e-7 Z",
    clipRule: "evenodd",
    id: "path847"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath884"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.03e-7,138.96 H 612 V 720 H 1.03e-7 Z",
    clipRule: "evenodd",
    id: "path882"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter9",
    x: -0.056823422,
    y: -0.03373563,
    width: 1.1136468,
    height: 1.0674713
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.45156575,
    id: "feGaussianBlur9"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter10",
    x: -0.15167942,
    y: -0.090050911,
    width: 1.3033588,
    height: 1.1801018
  }, _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2053697,
    id: "feGaussianBlur10"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter12",
    x: -0.20276097,
    y: -0.10538852,
    width: 1.4055219,
    height: 1.210777
  }, _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.37214663,
    id: "feGaussianBlur12"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter13",
    x: -0.47004336,
    y: -0.27461829,
    width: 1.9400867,
    height: 1.5492366
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.84915293,
    id: "feGaussianBlur13"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    style: {
      display: "inline",
      fill: "#ffcc00"
    },
    transform: "translate(-90.292128,-147.40632)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "9.92125px",
      lineHeight: 1.25,
      fontFamily: "Anton",
      InkscapeFontSpecification: "Anton",
      fill: "#ff0000",
      strokeWidth: 0.186023,
      filter: "url(#filter13)"
    },
    d: "m 103.2999,180.44999 q -2.15292,0 -2.15292,-2.18267 l 0.01,-0.57544 h 1.73621 l 0.01,0.85323 q 0,0.25795 0.0992,0.39685 0.0992,0.12898 0.3274,0.12898 0.34724,0 0.34724,-0.56551 0,-0.4167 -0.16866,-0.65481 -0.15874,-0.23811 -0.5159,-0.50598 l -0.92268,-0.71433 q -0.47622,-0.36709 -0.68457,-0.75402 -0.20834,-0.39685 -0.20834,-1.11118 0,-0.55559 0.28771,-0.94251 0.29764,-0.39685 0.78378,-0.59528 0.48614,-0.19842 1.08142,-0.19842 2.11323,0 2.11323,2.1033 v 0.1389 h -1.79575 v -0.2778 q 0,-0.25795 -0.0893,-0.43653 -0.0794,-0.18851 -0.2778,-0.18851 -0.17858,0 -0.27779,0.10914 -0.0893,0.0992 -0.0893,0.27779 0,0.39685 0.30756,0.61512 l 1.07149,0.78378 q 0.57543,0.42661 0.88299,0.9326 0.30756,0.49606 0.30756,1.26 0,1.01196 -0.57543,1.55763 -0.57543,0.54567 -1.60724,0.54567 z",
    id: "text3",
    transform: "scale(1.0333008,0.96777238)",
    "aria-label": "s"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "9.92125px",
      lineHeight: 1.25,
      fontFamily: "Anton",
      InkscapeFontSpecification: "Anton",
      fill: "#1a1a1a",
      strokeWidth: 0.186023
    },
    d: "m 103.2999,180.44999 q -2.15292,0 -2.15292,-2.18267 l 0.01,-0.57544 h 1.73621 l 0.01,0.85323 q 0,0.25795 0.0992,0.39685 0.0992,0.12898 0.3274,0.12898 0.34724,0 0.34724,-0.56551 0,-0.4167 -0.16866,-0.65481 -0.15874,-0.23811 -0.5159,-0.50598 l -0.92268,-0.71433 q -0.47622,-0.36709 -0.68457,-0.75402 -0.20834,-0.39685 -0.20834,-1.11118 0,-0.55559 0.28771,-0.94251 0.29764,-0.39685 0.78378,-0.59528 0.48614,-0.19842 1.08142,-0.19842 2.11323,0 2.11323,2.1033 v 0.1389 h -1.79575 v -0.2778 q 0,-0.25795 -0.0893,-0.43653 -0.0794,-0.18851 -0.2778,-0.18851 -0.17858,0 -0.27779,0.10914 -0.0893,0.0992 -0.0893,0.27779 0,0.39685 0.30756,0.61512 l 1.07149,0.78378 q 0.57543,0.42661 0.88299,0.9326 0.30756,0.49606 0.30756,1.26 0,1.01196 -0.57543,1.55763 -0.57543,0.54567 -1.60724,0.54567 z",
    id: "text11",
    transform: "scale(1.0333008,0.96777238)",
    "aria-label": "s"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      filter: "url(#filter10)"
    },
    d: "m 94.881492,183.61176 c 0,0 8.533648,-15.18992 9.493178,-16.6456 0.95953,-1.45567 9.5792,-15.47942 9.5792,-15.47942 0,0 -8.20026,14.57271 -8.98403,15.8407 -0.78375,1.26802 -10.088348,16.28432 -10.088348,16.28432 z",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      filter: "url(#filter9)"
    },
    d: "m 94.881492,183.61176 c 0,0 8.533648,-15.18992 9.493178,-16.6456 0.95953,-1.45567 9.5792,-15.47942 9.5792,-15.47942 0,0 -8.20026,14.57271 -8.98403,15.8407 -0.78375,1.26802 -10.088348,16.28432 -10.088348,16.28432 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ff0000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 94.881492,183.61176 c 0,0 8.533648,-15.18992 9.493178,-16.6456 0.95953,-1.45567 9.5792,-15.47942 9.5792,-15.47942 0,0 -8.20026,14.57271 -8.98403,15.8407 -0.78375,1.26802 -10.088348,16.28432 -10.088348,16.28432 z",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "9.85448px",
      lineHeight: 1.25,
      fontFamily: "Anton",
      InkscapeFontSpecification: "Anton",
      fill: "#ff0000",
      strokeWidth: 0.184771,
      filter: "url(#filter12)"
    },
    d: "m 103.55661,163.77109 -1.04458,-8.47485 h 1.61614 l 0.62083,5.76487 0.55185,-5.76487 h 1.61613 l -1.04457,8.47485 z",
    id: "text1",
    transform: "scale(0.97613354,1.02445)",
    "aria-label": "V"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontSize: "9.85448px",
      lineHeight: 1.25,
      fontFamily: "Anton",
      InkscapeFontSpecification: "Anton",
      fill: "#1a1a1a",
      strokeWidth: 0.184771
    },
    d: "m 103.55661,163.77109 -1.04458,-8.47485 h 1.61614 l 0.62083,5.76487 0.55185,-5.76487 h 1.61613 l -1.04457,8.47485 z",
    id: "text12",
    transform: "scale(0.97613354,1.02445)",
    "aria-label": "V"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsV003);
export default __webpack_public_path__ + "static/media/VS_v003.c367214661f498e6ba6bb7cec4b15609.svg";
export { ForwardRef as ReactComponent };